import { PUT_FOUNDERS_ERROR, PUT_FOUNDERS_START, PUT_FOUNDERS_SUCCESS } from '../../types';

export default function put_founders(state, action) {
  switch (action.type) {
    case PUT_FOUNDERS_START:
      return { ...state };
    case PUT_FOUNDERS_SUCCESS:
      return {
        ...state,
        data: action.results,
        error: null,
      };
    case PUT_FOUNDERS_ERROR:
      return {
        ...state,
        data: null,
        error: action.error
      };
    default:
      return { ...state };
  }
}